<template>
  <Teleport to="body">
    <div class="modal-overlay">
      <div class="modal-content" ref="modalContent">
        <div class="icon_wrapper">
          <svg
            class="check_icon"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 6L9 17L4 12"
              stroke="#0B485B"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <p class="main_text">Thank you for reaching out.</p>

        <div class="text_group">
          <p class="sub_text">We'll get back to you via</p>
          <p class="sub_text">the email address you provided.</p>
        </div>

        <div class="text_group">
          <p class="sub_text brand_text">DENTRION provides FDA-approved</p>
          <p class="sub_text brand_text">dental prosthetics.</p>
        </div>

        <button class="confirm-btn" @click="closeModal">OK</button>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: "MailSuccessModal",
  methods: {
    closeModal() {
      this.$emit("close");
    },
    handleResize() {
      const modalContent = this.$refs.modalContent;
      if (!modalContent) return;

      const windowWidth = window.innerWidth;
      const targetWidth = 412;
      const minScalingWidth = 340;

      if (windowWidth >= minScalingWidth && windowWidth < targetWidth) {
        const scale = windowWidth / targetWidth;
        modalContent.style.transform = `scale(${scale})`;
      } else {
        modalContent.style.transform = "";
      }
    },
  },
  mounted() {
    document.body.style.overflow = "hidden";
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    document.body.style.overflow = "auto";
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #939393;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  border-radius: 12px;
  padding: 40px 20px 16px 20px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.icon_wrapper {
  width: 48px;
  height: 48px;
  background: rgba(187, 224, 199, 0.20);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
}

.main_text {
  font-family: "Wanted Sans", -apple-system, BlinkMacSystemFont, system-ui,
    Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  font-size: 24px;
  font-weight: 900;
  color: #121212;
  margin-bottom: 24px;
  letter-spacing: -0.5px;
}

.text_group {
  margin-bottom: 16px;
}

.text_group:last-of-type {
  margin-bottom: 40px;
}

.sub_text {
  font-family: "Wanted Sans", -apple-system, BlinkMacSystemFont, system-ui,
    Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  font-size: 18px;
  color: #121212;
  line-height: 1.4;
  margin: 0;
  font-weight: 500;
}

.brand_text {
  color: #0b485b;
  
}

.confirm-btn {
  width: 100%;
  padding: 13px 0;
  background-color: #51c37e;
  color: #fff;
  font-family: "Wanted Sans", -apple-system, BlinkMacSystemFont, system-ui,
    Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  font-weight: 700;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  box-shadow: 4px 4px 4px 0 rgba(0, 0, 0, 0.10);
}

.confirm-btn:hover {
  background-color: #46ab6e;
}
</style>
